import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Text, Paragraph } = Typography;

export const FAQ = ({ setLoading, showMessage }) => {
    const faqs = [
        {
            question: 'چگونه می‌توانم یک رزرو جدید ایجاد کنم؟',
            answer: 'از منوی "رزرو جدید" می‌توانید با انتخاب اتاق، تاریخ و مشخصات زائرین محترم ، رزرو جدید ایجاد کنید.'
        },
        {
            question: 'آیا قرعه کشی پس از ثبت نام انجام می گردد؟',
            answer: 'در دوره هایی که تقاضای رزرو اتاق بیش از ظرفیت حسینیه می باشد ، قرعه کشی انجام می گردد.'
        },
        {
            question: 'آیا محدودیت ثبت نام برای افراد وجود دارد؟',
            answer: 'محدودیت عدم استفاده از خدمات حسینیه به مدت یکسال وجود دارد. در مواقع پیک مانند عید نوروز این محدودیت بیشتر خواهد شد .'
        },
        {
            question: 'آیا امکان ثبت نام برای افراد غیر نجف آبادی نیز وجود دارد؟',
            answer: 'این مکان جهت خدمات به همشریان محترم شهرستان نجف آباد می باشد و اولویت با ایشان می باشد. در صورت وجود ظرفیت امکان پذیرش از شهرستانهای مجاور استان اصفهان نیز وجود دارد.'
        },
        {
            question: 'امکان رزرو غذا نیز در این سامانه وجود دارد؟',
            answer: 'بله، پس از تایید ثبت نام و قطعی شدن وضعیت رزرو اتاق زائرین محترم می توانند از طریق همین سامانه نسبت به رزرو غذا و یا پارکینگ اقدام نمایند..'
        }
    ];

    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Title level={2}>سوالات متداول (FAQ)</Title>
                
                {faqs.map((faq, index) => (
                    <Card 
                        key={index} 
                        style={{ marginBottom: 16 }}
                        title={<Text strong>{faq.question}</Text>}
                    >
                        <Paragraph>{faq.answer}</Paragraph>
                    </Card>
                ))}
            </Card>
        </div>
    );
};